import React, { ReactElement } from 'react';
import { translatableText } from '../../utils/translatable-text';
import './hero-banner-v2.less';
import { Search } from '../search';

export enum Appearance {
    FULL = 'full',
    MINIMAL = 'minimal'
}

interface Props {
    searchField: ReactElement<typeof Search>;
    subHeader?: string;
    appearance?: 'full' | 'minimal';
}

export const HeroBannerV2 = (props: Props) => {
    const { searchField, subHeader, appearance = Appearance.FULL } = props;

    const baseClass = appearance === Appearance.MINIMAL ? '-minimal' : '-full';

    return (
        <section
            className={`hero-banner-v2${baseClass}`}
            data-testid="hero_banner_v2"
        >
            <div
                data-testid="hero_inner_v2"
                className={`hero-banner-v2${baseClass}__inner`}
            >
                {appearance === Appearance.FULL && (
                    <>
                        <h1
                            data-testid="hero_headline_v2"
                            className={`hero-banner-v2${baseClass}__headline`}
                        >
                            {translatableText.heroBannerHeadline.text}
                        </h1>
                        <p
                            data-testid="hero_subheadline_v2"
                            className={`hero-banner-v2${baseClass}__headline--secondary`}
                        >
                            {subHeader}
                        </p>
                    </>
                )}

                {searchField}
            </div>
        </section>
    );
};
